import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

// Components 
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import FormField from '../../../general/inputs/FormField';
import { setFirstName, setLastName, setEmail, setIsCredentialsSectionOpened, resetCreateGroupAccess } from '../../../../redux/features/doctor/group/createGroupAccess';
import DataBox from './DataBox';
import Button from '../../../general/inputs/Button';
import { createGroupAccess, verifyGroupAccessEmail } from '../../../../routes/doctor/account';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { useTranslation } from 'react-i18next';
import { setIsRefreshGroupAccessList } from '../../../../redux/features/doctor/group/groupAccess';
import { setDashboardSection, setIsAddSeatsPopupOpened, setIsGroupAccessInvitePopupOpened, setIsLoadingPopupOpened } from '../../../../redux/features/general/navigation';
import Section from '../../../general/containers/Section';

const CreateGroupAccess: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(); 

  const colors = useAppSelector(state => state.theme.colors); 
  const { firstName, lastName, email, isCredentialsSectionOpened } = useAppSelector(state => state.createGroupAccess); 

  const [error, setError] = useState('');  
  const [emailError, setEmailError] = useState(''); 
  
  const handleVerifyGroupAccessEmail = async () => { 
    const res = await verifyGroupAccessEmail(email) as any; 
    if (res.data.status == 200) { 
      dispatch(setIsCredentialsSectionOpened(true)); 
    } else if (res.data.status == 202) { 
      dispatch(setIsGroupAccessInvitePopupOpened(true)); 
    } else if (res.data.status === 401) {
      if (res.data.error === 'seatsLimit') { 
        dispatch(setIsAddSeatsPopupOpened(true)); 
      }; 
    } else { 
      setEmailError(res.data.error); 
    }; 
  }; 

  const handleEmail = (email: any) => { dispatch(setEmail(email)); }; 
  const handleFirstName = (firstName: any) => { dispatch(setFirstName(firstName)); }; 
  const handleLastName = (lastName: any) => { dispatch(setLastName(lastName)); }; 

  const handleCreateUser = async () => { 
      dispatch(setIsLoadingPopupOpened(true)); 
      const res = await createGroupAccess(firstName, lastName, email) as any; 
      dispatch(setIsLoadingPopupOpened(false)); 
      if (res.data.status === 200) { 
          dispatch(resetCreateGroupAccess()); 
          dispatch(setNotificationMessage(t('groupAccessCreated'))); 
          dispatch(setIsRefreshGroupAccessList(true)); 
          dispatch(setDashboardSection('groupAccessList'));
      } else if (res.data.status === 401) { 
          setError(res.data.error); 
      }; 
  }; 

  useEffect(() => { 
      setError(''); 
  },[firstName, lastName, email]);

  const navBarHeight = '5vh';
  const sideBarWidth = '70px';

  return (
    <Section
        extraStyle={{
            position: 'absolute',
            top: navBarHeight,
            left: sideBarWidth,
            width: `calc(100% - ${sideBarWidth})`,
            height: `calc(100% - ${navBarHeight})`,
            boxSizing: 'border-box',
            overflow: 'auto',
            padding: '2rem', // Use a stable unit for padding
            backgroundColor: colors?.container,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2rem'
        }}
    >
        {/* --- THIS IS THE FIX --- */}
        <DataBox 
          title={`${t('step')} 1`}
          description='emailValidation'
          extraStyle={{ 
            width: '100%',
            maxWidth: '600px' // It will be 100% wide on mobile, but max out at 600px on desktop
          }}
        >
          <FormField 
              icon={<MarkEmailReadIcon sx={{ color: colors?.email }} />}
              section={'email'}
              handler={handleEmail}
          />
          <Button 
              title='validate'
              triggerFunction={handleVerifyGroupAccessEmail}
              extraStyle={{ width: 100, marginTop: 4 }}
              isDisabled={isCredentialsSectionOpened ? true : false}
          />
        </DataBox>

        {isCredentialsSectionOpened && 
        <DataBox 
            title={`${t('step')} 2`}
            description='username'
            extraStyle={{ 
              width: '100%',
              maxWidth: '600px' // Same responsive style applied here
            }}
        >
            <FormField 
                icon={<AccountCircleIcon sx={{ color: colors?.lightBlue }} />}
                section={'firstName'}
                isFocused
                handler={handleFirstName}
            />
            <FormField 
                icon={<AccountCircleIcon sx={{ color: colors?.lastName }} />}
                section={'lastName'}
                handler={handleLastName}
            />
            <Button 
                title='createAccount'
                triggerFunction={handleCreateUser}
                extraStyle={{ width: 250, marginTop: 4 }}
            />
          </DataBox>}
    </Section>
  );
};

export default CreateGroupAccess;